import { NotificationTypename } from "./types";

export const NOTIFICATIONS_BASE_ROUTE = "/notifications";

export const notificationsSlugs: Record<
	Exclude<
		NotificationTypename,
		| "ConfirmIdentityDocumentDetailsNotification"
		| "AddInvestingEntityNotification"
	>,
	string
> = {
	VerifyAddressNotification: "verify-address",
	ProvideSourceOfFundsNotification: "provide-source-of-funds",
	VerifyIdentityNotification: "verify-identity",
	VerifyBiometricIdentityNotification: "verify-identity",
	ConfirmEmailAddressNotification: "confirm-email-address",
	ProvideBeneficialOwnerContactDetailsNotification:
		"provide-related-party-contact-details",
	ProvideCityOfBirthNotification: "provide-city-of-birth",
	ProvideInvestingEntityDocumentsNotification:
		"provide-investing-entity-documents",
	ReattemptVerifyBiometricIdentityNotification: "reattempt-verify-identity",
	ReattemptVerifyAddressNotification: "reattempt-verify-address",
	ReattemptProvideSourceOfFundsNotification:
		"reattempt-provide-source-of-funds",
	AddBankAccountNotification: "add-bank-account",
	VerifyBankAccountNotification: "verify-bank-account",
	RenewAccreditationNotification: "renew-accreditation",
	ConfirmAccreditationNotification: "confirm-accreditation",
	ReattemptConfirmAccreditationNotification: "reattempt-accreditation",
	ConfirmUnsupportedCountryAccreditationNotification: "confirm-accreditation",
};

type NotificationRoutes = Record<
	Exclude<
		NotificationTypename,
		| "ConfirmIdentityDocumentDetailsNotification"
		| "AddInvestingEntityNotification"
	>,
	string
>;

export const notificationsRoutes = ({
	id: notificationId,
}: {
	id?: string;
} = {}): NotificationRoutes => {
	const routes = {
		VerifyAddressNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.VerifyAddressNotification}`,
		ProvideSourceOfFundsNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ProvideSourceOfFundsNotification}`,
		VerifyIdentityNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.VerifyIdentityNotification}`,
		VerifyBiometricIdentityNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.VerifyBiometricIdentityNotification}`,
		ConfirmEmailAddressNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ConfirmEmailAddressNotification}`,
		ProvideBeneficialOwnerContactDetailsNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ProvideBeneficialOwnerContactDetailsNotification}`,
		ProvideCityOfBirthNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ProvideCityOfBirthNotification}`,
		ProvideInvestingEntityDocumentsNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ProvideInvestingEntityDocumentsNotification}`,
		ReattemptVerifyBiometricIdentityNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ReattemptVerifyBiometricIdentityNotification}`,
		ReattemptVerifyAddressNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ReattemptVerifyAddressNotification}`,
		ReattemptProvideSourceOfFundsNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ReattemptProvideSourceOfFundsNotification}`,
		AddBankAccountNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.AddBankAccountNotification}`,
		VerifyBankAccountNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.VerifyBankAccountNotification}${notificationId ? `/${notificationId}` : ""}`,
		RenewAccreditationNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.RenewAccreditationNotification}`,
		ConfirmAccreditationNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ConfirmAccreditationNotification}`,
		ReattemptConfirmAccreditationNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ReattemptConfirmAccreditationNotification}`,
		ConfirmUnsupportedCountryAccreditationNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ConfirmAccreditationNotification}`,
	};

	return routes;
};
